"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = require("../array");
function quote(s, q) {
    if (q === void 0) { q = '"'; }
    return q + s.replace(new RegExp(q, 'g'), '\\' + q) + q;
}
exports.quote = quote;
function unquote(s) {
    return s.substring(1, s.length - 1);
}
exports.unquote = unquote;
function repeat(n, s) {
    return array_1.array(n, s).join('');
}
exports.repeat = repeat;
function indent(i, tabSize) {
    if (i === void 0) { i = 1; }
    if (tabSize === void 0) { tabSize = 2; }
    return repeat(i * tabSize, ' ');
}
exports.indent = indent;
function wordWrap(s, w, newLine) {
    if (newLine === void 0) { newLine = '\n'; }
    var n = newLine.replace(/\\/, '\\\\');
    return s.replace(new RegExp("(?![^" + n + "]{1," + w + "}$)([^" + n + "]{1," + w + "})\\s", 'g'), "$1" + newLine);
}
exports.wordWrap = wordWrap;
//# sourceMappingURL=format.js.map